import ProfileRouter, { rootRouteName } from './types';

const Index = () => import('../Index.vue' /* webpackChunkName: "mentoring" */);

const MentoringRequests = () =>
  import('../views/requests' /* webpackChunkName: "requests" */);
const MentoringTeams = () =>
  import('../views/teams' /* webpackChunkName: "teams" */);
const MentoringPrograms = () =>
  import('../views/programs' /* webpackChunkName: "programs" */);
const MentoringInquiry = () =>
  import('../views/inquiry' /* webpackChunkName: "inquiry" */);

const MentoringNewRequests = () =>
  import('../views/newrequests' /* webpackChunkName: "newrequests" */);
const MentoringAllRequests = () =>
  import('../views/allrequests' /* webpackChunkName: "allrequests" */);
const MentoringCurrentRequests = () =>
  import('../views/currentrequests' /* webpackChunkName: "current" */);
const MentoringWorkingRequests = () =>
  import('../views/workingrequests' /* webpackChunkName: "working" */);
const MentoringCompletedRequests = () =>
  import('../views/completedrequests' /* webpackChunkName: "completed" */);
const MentoringRejectedRequests = () =>
  import('../views/rejectedrequests' /* webpackChunkName: "rejected" */);

const MentoringAllPrograms = () =>
  import('../views/allprograms' /* webpackChunkName: "allprograms" */);
const MentoringCurrentPrograms = () =>
  import('../views/currentprograms' /* webpackChunkName: "currentprog" */);
const MentoringCompletedPrograms = () =>
  import('../views/completedprograms' /* webpackChunkName: "completedprog" */);

const toName = (value: string) => [rootRouteName, value].join('-');
export const requestsRoutes = [
  {
    path: 'newrequests',
    component: MentoringNewRequests,
    name: toName('newrequests'),
    meta: { title: '+ Новый запрос', menuColor: 'green' },
    props: false,
  },
  {
    path: 'allrequests',
    component: MentoringAllRequests,
    name: toName('allrequests'),
    meta: { title: 'Все' },
    props: { tutoredId: false },
  },
  {
    path: 'currentreq',
    component: MentoringCurrentRequests,
    name: toName('currentreq'),
    meta: { title: 'Открыт' },
    props: { tutoredId: false },
  },
  {
    path: 'workingreq',
    component: MentoringWorkingRequests,
    name: toName('workingrequest'),
    meta: { title: 'В работе' },
    props: { tutoredId: false },
  },
  {
    path: 'completedreq',
    component: MentoringCompletedRequests,
    name: toName('completedreq'),
    meta: { title: 'Завершен' },
    props: { tutoredId: false },
  },
  {
    path: 'rejected',
    component: MentoringRejectedRequests,
    name: toName('rejected'),
    meta: { title: 'Отклонен' },
    props: { tutoredId: false },
  },
];

export const programsRoutes = [
  {
    path: 'allprograms',
    component: MentoringAllPrograms,
    name: toName('allprograms'),
    meta: { title: 'Все' },
  },
  {
    path: 'currentprog',
    component: MentoringCurrentPrograms,
    name: toName('currentprog'),
    meta: { title: 'Текущие' },
  },
  {
    path: 'completedprog',
    component: MentoringCompletedPrograms,
    name: toName('completedprog'),
    meta: { title: 'Завершенные' },
  },
];

export const mentoringRoutes = [
  {
    path: 'requests',
    component: MentoringRequests,
    name: toName('requests'),
    meta: { title: 'Запросы' },
    redirect: { name: toName('allrequests') },
    children: requestsRoutes,
  },
  {
    path: 'teams',
    component: MentoringTeams,
    name: toName('teams'),
    meta: { title: 'Команды' },
  },
  {
    path: 'programs',
    component: MentoringPrograms,
    name: toName('programs'),
    meta: { title: 'Программы' },
    redirect: { name: toName('allprograms') },
    children: programsRoutes,
  },
  {
    path: 'inquiry',
    component: MentoringInquiry,
    name: toName('inquiry'),
    meta: { icon: true },
  },
];

const createRoutes = ({ path, name, redirectTo404 }: ProfileRouter) => {
  const result = {
    path,
    name,
    component: Index,
    redirect: { name: toName('requests') },
    beforeEnter: redirectTo404('hasApiModuleMentoring'),
    children: mentoringRoutes,
  };

  return [result];
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/router/index.ts